var ContactForm = document.getElementById('form569c66073f88454f8752753ca2a94c88');
setTimeout(function() {
  // Your code to run after 1000ms
  console.log("Delayed code executed");
  // Add your specific scope of code here
  let Elements = {
          'ContactForm-price':
            document.getElementById('bfe9ed83-8a14-4862-a3b3-e44dad07e4c2'),
          'ContactForm-width':
            document.getElementById('2099cc02-0441-401c-b411-30406791e1c7'),
          'ContactForm-height':
            document.getElementById('9581a95f-9cfd-4ffb-bf70-7d42e19cdf10'),
          'ContactForm-length':
            document.getElementById('6cdcb867-b877-405d-8407-4b657f5799cc'),
          'ContactForm-quantity': document.getElementById('8d03d346-91b8-40dd-ae00-8a4f6e45b0c7'),
          'ContactForm-number': document.getElementById('3d2c0432-b934-4bb6-b924-3571e36f8ed7'),
          'ContactForm-numberof3Ddesigns': document.getElementById('57d2bf51-2d39-48b4-9139-ceeb8a17417f')
        
        };

  Elements['ContactForm-price'].setAttribute(
    'readonly',
    'true'
  );

  document.getElementById('2099cc02-0441-401c-b411-30406791e1c7').addEventListener('change', (e) => {
    
    e.stopPropagation();
    console.log('EVENTLISTEN');
    HandleChange(e);
  });
  document.getElementById('9581a95f-9cfd-4ffb-bf70-7d42e19cdf10').addEventListener('change', (e) => {
    
    e.stopPropagation();
    console.log('EVENTLISTEN');
    HandleChange(e);
  });
  document.getElementById('6cdcb867-b877-405d-8407-4b657f5799cc').addEventListener('change', (e) => {
    
    e.stopPropagation();
    console.log('EVENTLISTEN');
    HandleChange(e);
  });
  document.getElementById('8d03d346-91b8-40dd-ae00-8a4f6e45b0c7').addEventListener('change', (e) => {
    
    e.stopPropagation();
    console.log('EVENTLISTEN');
    HandleChange(e);
  });
   document.getElementById('3d2c0432-b934-4bb6-b924-3571e36f8ed7').addEventListener('change', (e) => {
    
    e.stopPropagation();
    console.log('EVENTLISTEN');
    HandleChange(e);
  });
  document.getElementById('57d2bf51-2d39-48b4-9139-ceeb8a17417f').addEventListener('change', (e) => {
    
    e.stopPropagation();
    console.log('EVENTLISTEN');
    HandleChange(e);
  });
  document.getElementById('f36c7b96-a57c-4ff4-9600-e3b1bb2c9667').removeEventListener('change', function () {});
  document.getElementById('bb91084e-c9b7-40b6-b01d-29d264186485').removeEventListener('change', function () {});


  function HandleChange(e) {
    console.log('CHANHGE', e.target);
    let LABOUR_COST = 30; // labor cost
const DESIGN_COST = 35; // design addition cost
const PRICE_PARAMETER = 0.0007; // price parameter
const ICON_PRICE_PARAMETER = Elements['ContactForm-number'].value * 110; // icon price paramer
    
// Calculating the size of the design icon
let CalculatedSize =
  Elements['ContactForm-width'].value *
  Elements['ContactForm-height'].value *
  Elements['ContactForm-length'].value;

// Setting variable for the number of icons
let NumberOfIcons = Elements['ContactForm-number'].value;

// Setting variable for the additional design cost
let NoOfAdditionalDesigns = Elements['ContactForm-numberof3Ddesigns'].value;
    
// Setting value for CalculatedArea
let CalculatedArea = CalculatedSize * NumberOfIcons;
    
// Applying discounts to LABOUR_COST based on CalculatedArea
if (CalculatedArea < 200) {
  LABOUR_COST *= 0.75; // Smaller items have a lower labour addition because it's easy to make loads by replicating cast
}
// Set additional Design Cost
    let AdditonalDesignCost = 45
// Setting variable for the quantity of moulds
let Quantity = Elements['ContactForm-quantity'].value;

// Factoring in labour costs for each additional mould made
let LabourCostPerExtraMould = Quantity * LABOUR_COST;

let CalculatedPrice = DESIGN_COST + PRICE_PARAMETER * (CalculatedSize * ICON_PRICE_PARAMETER * Quantity) + LabourCostPerExtraMould ;

// Applying discounts based on CalculatedPrice
if (CalculatedPrice > 750) {
  CalculatedPrice *= 0.5; // Apply 50% discount
} else if (CalculatedPrice > 500) {
  CalculatedPrice *= 0.6; // Apply 40% discount
} else if (CalculatedPrice > 250) {
  CalculatedPrice *= 0.7; // Apply 30% discount
} else if (CalculatedPrice > 150) {
  CalculatedPrice *= 0.8; // Apply 20% discount
}

    CalculatedPrice += ((NoOfAdditionalDesigns-1) * AdditonalDesignCost);
console.log(CalculatedPrice);
Elements['ContactForm-price'].setAttribute('value', Number(CalculatedPrice.toFixed(0)));
Elements['ContactForm-price'].dispatchEvent(new Event('input', { bubbles: true }));

    
  }
}, 3000);

